import { Card, Grid, Typography, Button } from '@mui/material';
import React from 'react';
import { Document, Page, } from 'react-pdf';
import LOGO from "../../assets/images/big/empowercare.png";
// Set the workerSrc for pdfjs
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const PdfViewer = ({ file }) => {

    const [numPages, setNumPages] = React.useState(null);
    const [pageNumber, setPageNumber] = React.useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <div>

            <Card elevation={0} mt={-10} sx={{ borderRadius: '0px', padding: '5px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', }}>
                <Grid container alignItems="center" justifyContent="space-between"  >
                    <Grid item>
                        <Typography > Page {pageNumber} of {numPages}</Typography>
                    </Grid>
                    <Grid item>    <img src={LOGO} alt="logo" width="183.54px" height="30px" /></Grid>

                    <Grid item sx={{ mr: 1 }}>
                        <Button
                            variant="outlined"
                            disabled={pageNumber <= 1}

                            onClick={() => setPageNumber(pageNumber - 1)}
                            sx={{ mr: 1 }} // adds spacing between buttons
                        >
                            Previous
                        </Button>
                        <Button
                            variant="outlined"
                            disabled={pageNumber >= numPages}
                            onClick={() => setPageNumber(pageNumber + 1)}

                        >
                            Next
                        </Button>
                    </Grid>



                </Grid>

            </Card>
            <div style={{ minHeight: '720px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: "#f5f5f5" }}>
                <Document
                    file={file}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<Typography>Loading PDF...</Typography>}
                >
                    <Page
                        pageNumber={pageNumber}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        width={600} // optional: control width
                    />
                </Document>
            </div>
        </div>
    );
};

export default PdfViewer;
